import { type JSX } from 'react/jsx-runtime';

export const CONNECTOR_DARK = (): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 275 275" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M43.41 114.74C43.59 151.5 43.64 191.23 43 190.76C43 190.76 81.56 195.34 124.64 196.21V124.57H43.46C43.45 121.29 43.43 118 43.41 114.74Z"
			fill="#AF59E0"
		/>
		<path
			d="M124.619 64.4904H124.629V124.57H208.239V55.1504C208.239 55.1504 171.289 64.2004 124.619 64.5004V64.4904Z"
			fill="#1558BC"
		/>
		<path
			d="M119.85 64.491C119.85 64.491 119.76 64.491 119.72 64.491C95.24 64.321 68.41 61.651 43 54.001C43.01 55.221 43.31 90.261 43.46 124.571H124.64V64.491C124.64 64.491 124.56 64.491 124.51 64.491C122.97 64.491 121.41 64.491 119.85 64.491Z"
			fill="#6A9A23"
		/>
		<path
			d="M152.07 134.251L132.02 203.071C160.04 211.851 190.56 219.551 213.94 220.641L232.3 157.621L152.07 134.251Z"
			fill="#E56E00"
		/>
	</svg>
);
